import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../../utils/types";
import { getUserById } from "../../../../../redux/educator/actions";
import {
  selectUser,
  selectUserLoading,
  selectUserLoaded,
} from "../../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  user: selectUser(state),
  loading: selectUserLoading(state),
  loaded: selectUserLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getUserById,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
